export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-chart-line',
        permission: 'dashboard',
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Finances',
        icon: 'cil-dollar',
        permission: 'finance',
        items: [
          {
            name: 'Revenue',
            to: '/revenue',
          },
          {
            name: 'Discounts',
            to: '/discounts',
          },
          {
            name: 'Credits outstanding',
            to: '/credits_outstanding',
          },
          {
            name: 'Affiliates',
            to: '/affiliates',
          },
          {
            name: 'Invoices',
            to: '/invoices',
          },
          // {
          //   name: 'SPs owed',
          //   to: '/sp_owed',
          // },
          {
            name: 'SPs balance outstanding',
            to: '/sp_balance_outstanding',
          },
          {
            name: 'SPs fee owed',
            to: '/sp_fee_owed',
          },
        ],
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Promotions',
        icon: 'cil-star',
        permission: 'promotion',
        items: [
          {
            name: 'Restrictions',
            to: '/promotions',
          },
          {
            name: 'Codes',
            to: '/promotion-codes',
          },
        ],
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Consumers',
        to: '/consumers',
        icon: 'cil-user',
        permission: 'consumer',
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Providers',
        icon: 'cil-puzzle',
        permission: 'provider',
        items: [
          {
            name: 'SP accounts',
            to: '/sp/accounts',
          },
          {
            name: 'SP applications',
            to: '/sp/applications',
          },
          {
            name: 'Expiring insurances',
            to: '/sp/insurances',
          },
          {
            name: 'Request new categories',
            to: '/sp/request_new_categories',
          },
        ],
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Providers',
      //   to: '/providers',
      //   icon: 'cil-puzzle',
      //   permission: 'provider',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Services',
      //   to: '/services',
      //   icon: 'cil-star',
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Bookings',
        to: '/bookings',
        icon: 'cil-chart-pie',
        permission: 'booking',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Announcements',
        to: '/announcements',
        icon: 'cil-bell',
        permission: 'announcement',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'User Internals',
        to: '/user-internals',
        permission: 'admin',
        icon: 'cil-user',
      },
    ],
  },
];
